import { Component, Input, OnDestroy } from '@angular/core';
import { DialogRef, DialogCloseResult } from '@progress/kendo-angular-dialog';
import { FocusManagedDialogComponent } from '../focus-managed-dialog.component';
import { FocusService } from '@/core/services/focus.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent extends FocusManagedDialogComponent{


  @Input()
  public content: string = "";

  @Input()
  public showCancel: boolean = true;

  @Input()
  public cancel: string = "";

  @Input()
  public confirm: string = "";

  public get confirmText(): string {
    return this.confirm ? this.confirm : "conformationDialog.confirm";
  }

  public get cancelText(): string {
    return this.cancel ? this.cancel : "conformationDialog.cancel";
  }

  constructor(protected focusService: FocusService, dialog: DialogRef) {
    super(focusService,dialog);
  }


  public onCancelClick() {
    let result: ConfirmationDialogResult = new ConfirmationDialogResult();

    result.action = ConfirmationDialogAction.Cancel;
    
    this.dialog.close(result);
  }

  public onConformClick() {
    let result: ConfirmationDialogResult = new ConfirmationDialogResult();

    result.action = ConfirmationDialogAction.Confirm;

    this.dialog.close(result);
  }


}

export class ConfirmationDialogResult extends DialogCloseResult {
  public action: ConfirmationDialogAction;
}

export enum ConfirmationDialogAction {
  Confirm,
  Cancel
}
